<template>
    <div class="img-loader" v-lazy-container="{ selector: 'img'}">
        <img :data-src="src" :alt="alt" />
    </div>
</template>

<style>
    .img-loader img {
        transition: all .2s;
    }
    .img-loader img[lazy=loading] {
        opacity: 0;
    }
    .img-loader img[lazy=error] {
        /*your style here*/
    }
    .img-loader img[lazy=loaded] {
        opacity: 1;
    }
</style>

<script>

    export default {

        props: {

            src: {
                required: true
            },

            alt: {}
        }

    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/ImageLoader.vue